import React from 'react';

import styled from 'styled-components';

import Visibility from 'assets/images/visibility.svg';
import VisibilityOff from 'assets/images/visibility_off.svg';

const Wrapper = styled.div`
  min-height: 90vh;
  padding: 14.9vh 16px 8.6vh;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  background-color: var(--colorBlueGray100);
  font-family: 'Poppins';

  @media all and (min-height: 1400px) {
    min-height: 93vh;
  }
`;

const InnerWrapper = styled.div`
  width: 368px;
  display: flex;
  flex-flow: column nowrap;
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 500;
  line-height: 56px;
  margin: 0 0 32px;
  color: #1c2733;
`;

const Form = styled.form`
  margin-bottom: 24px;
`;

const InputWrapper = styled.div`
  position: relative;

  &:last-of-type {
    margin-bottom: 32px;
  }
`;

const Label = styled.p`
  color: var(--colorBlueGray800);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.24px;
  line-height: 24px;
  margin: 0 0 8px 0;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 1px solid #c3c5c7;
  height: 64px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1c232c;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: #1c232c;
    outline: none;
  }

  @media (max-width: 680px) {
    font-size: 16px;
  }
`;

const VisibilityIcon = styled.div<{
  isVisible: boolean;
}>`
  position: absolute;
  right: 16px;
  width: 24px;
  height: 24px;
  bottom: 12px;
  background-color: #b0b3b6;
  mask-image: ${(props) =>
    props.isVisible ? 'url(' + Visibility + ')' : 'url(' + VisibilityOff + ')'};
`;

const SubmitButton = styled.button<{
  disabled: boolean;
}>`
  background: linear-gradient(-180deg, rgb(65, 71, 79) 0%, rgb(28, 35, 44) 100%);
  border-radius: 4px;
  height: 64px;
  width: 100%;
  border: none;
  outline: none;
  appearance: none;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins';
  letter-spacing: 0.24px;
  display: block;
  padding: 16px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: opacity 0.2s ease-in-out;
`;

const ErrorMessage = styled.p`
  color: #ff263d;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.29px;
  line-height: 16px;
  margin: 0 0 16px;
`;

const RegisterText = styled.p`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Eina';
  text-align: center;
  margin-top: 32px;
`;

const RegisterLinkWrapper = styled.span`
  padding-left: 3px;
`;

export {
  Wrapper,
  ErrorMessage,
  SubmitButton,
  VisibilityIcon,
  Label,
  InnerWrapper,
  InputWrapper,
  Input,
  Form,
  Title,
  RegisterText,
  RegisterLinkWrapper,
};
